import { render, staticRenderFns } from "./ListCourses.vue?vue&type=template&id=ac52e1b8&"
import script from "./ListCourses.vue?vue&type=script&lang=js&"
export * from "./ListCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VDataTable})
